import React from 'react';
import {Col, Form, Row} from "react-bootstrap";
import {Multiselect} from 'multiselect-react-dropdown';
import "../../Styles/BenutzerManagement/EditRolesForm.css"

const EditRolesForm = (elem) => {
    return (
        <Form.Group as={Row}
                    controlId="formEditRoles">
            <Col sm="3">
                <Form.Label>Rolle:</Form.Label>
            </Col>
            <Col>
                <Multiselect
                    className="chip multiSelectContainer optionContainer searchBox"
                    options={elem.props.allowedRoles}
                    selectedValues={elem.props.userRoles}
                    onSelect={elem.onSelectedRoleChange}
                    onRemove={elem.onSelectedRoleChange}
                    displayValue="role"
                    showCheckbox="true"
                    closeOnSelect="False"
                    avoidHighlightFirstOption="False"
                    hidePlaceholder="true"
                    selectionLimit="-1"
                /><p className="editFormColColor">{elem.props.errorMessageRole}</p>
            </Col>
        </Form.Group>

    )
};

export default EditRolesForm